
import React, { useContext, useEffect, useState } from 'react';
import { 
  Col, 
  Container, 
  Row, 
  Form,
  Modal, 
} from 'react-bootstrap';
import { FaPlus, FaExclamationCircle } from 'react-icons/fa';
import { Button, ButtonGroup } from '@/shared/components/Button';
import toast from 'react-hot-toast';
import Pagination from 'react-bootstrap/Pagination'; 
import AgentCard from './AgentCard';
import { AuthContext } from '../../context/AuthContext';
import { AgentContext } from '../../context/AgentContext';
import { ThemeContext } from '../../context/ThemeContext';
import ProgressBars from '../Admin/Loader';
import { SideBarRefreshContext } from '../../context/SideBarRefreshContext';

import AddAgent from './AddAgent';
import { PermissionContext } from '../../context/PermissionContext';

const Search = () => {
  const [agent, setAgent] = useState([]);
  const { sideBarRefresh } = useContext(SideBarRefreshContext);
  const [filteragent, setFilterAgent] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const { setRefresh, refresh, setRefreshRequest } = useContext(AgentContext);
  const { currentTheme } = useContext(ThemeContext);
  const { apiGlobal, userid, countryid } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const { permissionsAccess } = useContext(PermissionContext);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Pagination Logic - Slice data for the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Use filteragent for pagination, not agent
  const currentItems = filteragent.slice(indexOfFirstItem, indexOfLastItem);

  // Total pages should be based on filteragent length, not agent
  const totalPages = Math.ceil(filteragent.length / itemsPerPage);

 // Generate a range of pagination items, including "..."
const pageNumbers = [];
const maxVisiblePages = 3; // This will display only 3 page numbers (e.g., 1, 2, 3 or 2, 3, 4)
const startPage = Math.max(1, currentPage - 1); // Allow for 1 page before
const endPage = Math.min(totalPages, currentPage + 1); // Allow for 1 page after

// Add the page numbers in the range of startPage to endPage
for (let i = startPage; i <= endPage; i += 1) {
  pageNumbers.push(i);
}

// If the first page is greater than 1, add '...'
if (startPage > 1) {
  pageNumbers.unshift('...');
}

// If the last page is less than the total pages, add '...'
if (endPage < totalPages) {
  pageNumbers.push('...');
}

// Add the last page number if it's not already in the array
if (pageNumbers[pageNumbers.length - 1] !== totalPages) {
  pageNumbers.push(totalPages);
}


const fetchData = async () => {
  // console.log('Fetching data...');
  setIsLoading(true);
   const formData = new FormData();
   formData.append('country_id', countryid);
  try {
    const response = await fetch(`${apiGlobal}agent_data.php`, {
      method: 'POST',
      body: formData,
    });
    const data = await response.json();
    // console.log('Data fetched:', data);
    if (data.status && data.message === 'Success') {
      setAgent(data.data);
      setFilterAgent(data.data);
    } else {
      // console.log('No data fetched');
      setFilterAgent([]);
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    toast.error('Failed to load data');
  } finally {
    // console.log('Setting loading state to false');
    setIsLoading(false); // Ensure the loader is removed after fetching
  }
};
  useEffect(() => {
    fetchData();
  }, [refresh, sideBarRefresh?.adminAgentRefresh]);

  // Handler Function for Adding Agent
  const handleSubmit = async (formValues) => {
     // console.log(JSON.stringify(formValues, null, 2));

      const formData = new FormData();
     
      if (formValues.file.size > 1048576) {
        toast.error("File is too large. Please select a file smaller than 1 MB.'");
        return;
    }

    if (!formValues.country_code) {
      toast.error('Please select a country code.');
      return;
    }
    if (!formValues.country) {
      toast.error('Please select a country');
      return;
    }


     
  
      formData.append('agentName', formValues.agentName);
      formData.append('user_email', formValues.email);
      formData.append('user_phone', formValues.phone_no);
      formData.append('country_code', formValues.country_code?.value);
      formData.append('uan', formValues.uan);
      formData.append('addressLine1', formValues.addressline1);
      formData.append('addressLine2', formValues.addressline2);
      formData.append('area', formValues.area);
      formData.append('city', formValues.city);
      formData.append('state', formValues.state);
      formData.append('country', formValues.country?.value);
      formData.append('pincode', formValues.pincode);
      formData.append('locationOnMap', formValues.location);
      formData.append('logo', formValues.file);
      formData.append('gst_no', formValues.gst_no);
      formData.append('gst_type', formValues.gst_type);
      formData.append('gst_proof_file', formValues.gst_proof);
      formData.append('address_proof_file', formValues.address_proof);
      formData.append('defaultMarkup', formValues.markup);
      formData.append('taxId', formValues.taxId);
      formData.append('taxCity', formValues.taxCity);

      formData.append('type', 0);
      formData.append('user_id', userid);
  
      try {
        const response = await fetch(`${apiGlobal}/agent_add.php`, {
          method: 'POST',
          body: formData,
        });
  
        const data = await response.json();
        if (data.status) {
          toast.success('Agent added successfully!');
         
          setShowModal(false); 
          setRefresh(prev => !prev);
          setRefreshRequest(prev => !prev);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        alert(`An Error Occurred: ${error.message}`);
        console.error('Submit Error:', error);
      }
    };
     

 
  // handle for search 
  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query) {
      const filteredData = agent.filter(agentdata => agentdata.name.toLowerCase().includes(query.toLowerCase())
        || agentdata.city.toLowerCase().includes(query.toLowerCase())
        || agentdata.state.toLowerCase().includes(query.toLowerCase())
        || agentdata.country.toLowerCase().includes(query.toLowerCase()));
      setFilterAgent(filteredData);
    } else {
      setFilterAgent(agent);
    }
  };


  // use Effect to add keyframes for the pulse animation
  useEffect(() => {
    // Add keyframes via JavaScript when component mounts
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes pulse {
        0% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.2); opacity: 0.8; }
        100% { transform: scale(1); opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }, []);


  // refresh button handler
  const refreshHandler = () => {
    setRefresh(prev => !prev);
    setSearchQuery('');
    toast.success('Refresh....');
  };


  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          // justifyContent: 'center', // Center horizontally
          // alignItems: 'center', // Center vertically
          height: '100vh', // Full viewport height
        }}
      >
        <ProgressBars />
      </div>
    );
  }
  

  // if (agent.length <= 0) {
  //   return <div>No Agent Found</div>;
  // }

  return (
    <Container>
      <Row>
        <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
          <div style={{
 display: 'flex', width: '25%', marginBottom: '10px', marginTop: '10px', alignItems: 'center', 
}}
          >
            <Form.Control
              type="text"
              placeholder="Search by Name, City, State......"
              value={searchQuery}
              onChange={handleSearch}
              style={{
        backgroundColor: currentTheme === 'Dark' ? '#232329' : 'white',
        color: currentTheme === 'Dark' ? 'white' : 'black',
        height: '30px',
        marginTop: '5px',
        borderColor: 'green',
        flexGrow: 1,
      }}
            />

            <ButtonGroup icons dir="ltr" style={{ marginTop: '10px' }}>
              <Button
                variant="outline-secondary"
                title="Refresh"
                size="sm"
                style={{ marginLeft: '10px' }}
                onClick={refreshHandler}
              >
                <span className="lnr lnr-sync" />
              </Button>
            </ButtonGroup>
          </div>

          {/* Add Agent button aligned to the right */}
          {permissionsAccess?.[0]?.master_id === '1'
    && permissionsAccess?.[0]?.create === 1 && (
      <Button
        variant="outline-primary"
        size="sm"
        onClick={() => setShowModal(true)}
        style={{
          marginLeft: 'auto',
          marginTop: '10px',
        }}
      >
        <span>Add Agent</span>
        <FaPlus />
      </Button>
    )}
        </div>


       
      </Row>
      

      <Row>
        <Container>
          {currentItems.length > 0 ? (
            currentItems.map(agentdata => (
              <AgentCard
                key={agentdata.id}
                id={agentdata.id}
                activestatus={agentdata?.active_status}
                agentName={agentdata.name}
                uan={agentdata.uan}
                addressline1={agentdata.address1}
                addressline2={agentdata.address2}
                area={agentdata.area}
                city={agentdata.city}
                state={agentdata.state}
                countryPhoneCode={agentdata.country_code} // store country phone code
                countryCode={agentdata.country_code_id} // store phone country code
                country={agentdata.country} // this store store country id
                countryName={agentdata.country_name} // this store store the actual country name
                pincode={agentdata.pincode}
                logo={agentdata.logo}
                gstNo={agentdata.gst_no}
                gstType={agentdata.gst_type}
                gstProof={agentdata.gst_proof_file}
                addressProof={agentdata.address_proof_file}
                location={agentdata.location}
                defaultMarkup={agentdata.markup}
                taxId={agentdata.tax_id}
                taxCity={agentdata.tax_city}
                userName={agentdata.user_name}
                userEmail={agentdata.user_email}
                userPhone={agentdata.user_phone}
                uin={agentdata.uin}
                accName={agentdata.acc_name}
                accountNo={agentdata.account_no}
                ifscCode={agentdata.ifsc_code}
                branch={agentdata.branch}
                bank={agentdata.bank}
                accCity={agentdata.acc_city}
                accCountry={agentdata.acc_country}
                accCountryName={agentdata.acc_country_name} // store the actual country name
                password={agentdata.password}
                upperlimit={agentdata.upper_limit}
                theme={currentTheme}
              />
            ))
          ) : (
            // If search results are empty
            <div style={{
              textAlign: 'center',
  padding: '50px',
  backgroundColor: '#f8d7da',
  borderRadius: '8px',
  marginTop: '20px',
              color: '#721c24',
  fontSize: '16px',
            }}
            >
              <div
                style={{
fontSize: '48px',
marginBottom: '20px',
color: '#e63946',
animation: 'pulse 1.5s infinite ease-in-out',
display: 'inline-block',
}}
              >
                <FaExclamationCircle style={{ fontSize: '48px', marginBottom: '20px' }} />
              </div>
              <p>{searchQuery ? 'No results found for your search' : 'No Agent available'}</p>
            </div>
          )}
        </Container>
      </Row>
      <div
        style={{
    bottom: '20px',
    right: '20px',
    zIndex: 999,
    display: 'flex',
    padding: '10px',
    justifyContent: 'flex-end',
    alignItems: 'center',
  }}
      >
        <Pagination>
          <Pagination.Prev
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {pageNumbers.map((number, index) => (number === '...' ? (
            <Pagination.Ellipsis key={number} />
      ) : (
        <Pagination.Item
          key={number}
          active={number === currentPage}
          onClick={() => handlePageChange(number)}
        >
          {number}
        </Pagination.Item>
      )))}
          <Pagination.Next
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>

      {/* Add Agent Modal */}
      {/* Modal for Adding Agent */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="xl"
        
      >
        <Modal.Header
          style={{
          backgroundColor: currentTheme === 'Dark' && '#232329',
          color: currentTheme === 'Dark' && '#fff',
        }}
          closeButton
          closeVariant={currentTheme === 'Dark' && 'white'}
        >
          <Modal.Title>Add Agent
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
          backgroundColor: currentTheme === 'Dark' && '#232329',
        }}
        >
          <AddAgent onSubmit={handleSubmit} />
        </Modal.Body>
      </Modal>

    </Container>
  );
};

export default React.memo(Search);


// import React, { useContext, useEffect, useState } from 'react';
// import { 
//   Col, 
//   Container, 
//   Row, 
//   Form, 
// } from 'react-bootstrap';
// import { Button, ButtonGroup } from '@/shared/components/Button';
// import { FaFilter } from 'react-icons/fa';
// import toast from 'react-hot-toast';
// import Pagination from 'react-bootstrap/Pagination';
// import AgentCard from './AgentCard';
// import { AuthContext } from '../../context/AuthContext';
// import { AgentContext } from '../../context/AgentContext';
// import { ThemeContext } from '../../context/ThemeContext';

// const Search = () => {
//   const [agent, setAgent] = useState([]);
//   const [filteragent, setFilterAgent] = useState([]);
//   const [searchQuery, setSearchQuery] = useState('');
//   const { setRefresh, refresh } = useContext(AgentContext);
//   const { currentTheme } = useContext(ThemeContext);
//   const { apiGlobal } = useContext(AuthContext);

//   // Pagination state
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 5;

//    // Handle page change
//    const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   // Pagination Logic - Slice data for the current page
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = agent.slice(indexOfFirstItem, indexOfLastItem);

//   // Total pages
//   const totalPages = Math.ceil(agent.length / itemsPerPage);



//     const fetchData = async () => {
//       const response = await fetch(`${apiGlobal}agent_data.php`);
//       const data = await response.json();
//       if (data.status && data.message === 'Success') {
//         setAgent(data.data);
//         setFilterAgent(data.data);
//       } else {
//         console.log('No data fetched');
//         setFilterAgent([]);
//       }
//     };


//   useEffect(() => {
//     fetchData();
//   }, [refresh]);
  

//   if (agent.length <= 0) {
//     return (
//       <div>
//         No Agent Found
//       </div>
//     );
//   }
  
//   const handleSearch = (e) => {
//     const query = e.target.value;
//     setSearchQuery(query);

//     if (query) {
//       const filteredData = agent.filter(agentdata => agentdata.name.toLowerCase().includes(query.toLowerCase())
//         || agentdata.city.toLowerCase().includes(query.toLowerCase())
//         || agentdata.state.toLowerCase().includes(query.toLowerCase())
//         || agentdata.country.toLowerCase().includes(query.toLowerCase()));
//       setFilterAgent(filteredData);
//     } else {
//       setFilterAgent(agent);
//     }
//   };

//   const refreshHandler = () => {
//     setRefresh(prev => !prev);
//     toast.success('Refresh....');
//   };

//   return (
//     <Container>
//       <Row>
//         <Col md={12} />
//       </Row>
//       <Row>
//         <div className="col-md-4 mb-4 d-flex align-items-center">
//           <Form.Control
//             type="text"
//             placeholder="Search by Name, City, State, or Country"
//             value={searchQuery}
//             onChange={handleSearch}
//             className="flex-grow-1"
//             style={{
//               backgroundColor: currentTheme === 'Dark' ? '#232329' : 'white',
//               color: currentTheme === 'Dark' ? 'white' : 'black',
//             }}
//           />

//           <ButtonGroup icons dir="ltr" className="mt-2">
//             <Button
//               variant="outline-secondary"
//               className="ms-3"
//               title="Refresh"
//               size="sm"
//               onClick={refreshHandler}
//             >
//               <span className="lnr lnr-sync" />
//             </Button>
//           </ButtonGroup>
//           <ButtonGroup icons dir="ltr" className="mt-2 mx-2">
//             <Button variant="outline-info" title="Filter">
//               <FaFilter />
//             </Button>
//           </ButtonGroup>
//         </div>
//       </Row>
//       <Row>
//         <Container>
//           {filteragent.length > 0 ? (
//             filteragent.map(agentdata => (
//               <AgentCard
//                 key={agentdata.id}
//                 id={agentdata.id}
//                 agentName={agentdata.name}
//                 uan={agentdata.uan}
//                 addressline1={agentdata.address1}
//                 addressline2={agentdata.address2}
//                 area={agentdata.area}
//                 city={agentdata.city}
//                 state={agentdata.state}
//                 country={agentdata.country}
//                 pincode={agentdata.pincode}
//                 logo={agentdata.logo}
//                 gstNo={agentdata.gst_no}
//                 gstType={agentdata.gst_type}
//                 gstProof={agentdata.gst_proof_file}
//                 addressProof={agentdata.address_proof_file}
//                 location={agentdata.location}
//                 defaultMarkup={agentdata.markup}
//                 taxId={agentdata.tax_id}
//                 taxCity={agentdata.tax_city}
//                 userName={agentdata.user_name}
//                 userEmail={agentdata.user_email}
//                 userPhone={agentdata.user_phone}
//                 uin={agentdata.uin}
//                 accName={agentdata.acc_name}
//                 accountNo={agentdata.account_no}
//                 ifscCode={agentdata.ifsc_code}
//                 branch={agentdata.branch}
//                 bank={agentdata.bank}
//                 accCity={agentdata.acc_city}
//                 accCountry={agentdata.acc_country}
//                 password={agentdata.password}
//                 theme={currentTheme}
//               />
//             ))
//           ) : (
//             <div>No agents found.</div>
//           )}
          
//         </Container>
//       </Row>
//       {/* Pagination Controls */}
//       <div style={{
//  position: 'fixed', 
//         bottom: '20px', 
//         right: '20px', 
//         zIndex: 999, 
//         display: 'flex', 
//         justifyContent: 'center', 
//         alignItems: 'center', 
// }}
//       >
//         <Pagination>
//           <Pagination.Prev
//             onClick={() => handlePageChange(currentPage - 1)}
//             disabled={currentPage === 1}
//           />
//           {Array.from({ length: totalPages }, (_, index) => (
//             <Pagination.Item
//               key={index + 1}
//               active={index + 1 === currentPage}
//               onClick={() => handlePageChange(index + 1)}
//             >
//               {index + 1}
//             </Pagination.Item>
//   ))}
//           <Pagination.Next
//             onClick={() => handlePageChange(currentPage + 1)}
//             disabled={currentPage === totalPages}
//           />
//         </Pagination>

//       </div>
//     </Container>
//   );
// };

// export default Search;
